export default "__VITE_ASSET__9d10bd0e__"